// Refactor 02/2026 — extrahiert aus AppointmentsPage.js. Read-Only Overlay
// für direkt in Mindbody gebuchte Slots (BELEGT-Streifen).
import React from 'react';
import { getSwissHM } from './calendarUtils';

const groupMindbodySlots = (mbRaw) => {
  return Object.values(
    mbRaw.reduce((acc, mb) => {
      const key =
        mb.source_type === 'appointment'
          ? `apt|${mb.start_time}|${mb.end_time}`
          : `solo|${mb.id}`;
      if (!acc[key]) acc[key] = { ...mb, _count: 0, _capacity: 1 };
      acc[key]._count += 1;
      acc[key]._capacity = Math.max(acc[key]._capacity, mb.group_capacity || 1);
      return acc;
    }, {})
  );
};

export const MindbodyOverlay = ({
  trainerId,
  mindbodySlotsByTrainer,
  calendarStartMinutes,
  slotHeight,
}) => {
  const mbRaw = mindbodySlotsByTrainer[trainerId] || [];
  if (!mbRaw.length) return null;

  return (
    <>
      {groupMindbodySlots(mbRaw).map((mb) => {
        try {
          const startDate = new Date(mb.start_time);
          const endDate = new Date(mb.end_time);
          const sStart = getSwissHM(mb.start_time);
          const startMinutesFromMidnight = sStart.hour * 60 + sStart.minute;
          const minutesFromCalendarStart =
            startMinutesFromMidnight - calendarStartMinutes;
          const durationMinutes = Math.max(
            15,
            (endDate - startDate) / (1000 * 60)
          );
          const topPosition = (minutesFromCalendarStart / 30) * slotHeight;
          const height = (durationMinutes / 30) * slotHeight;
          if (topPosition < -height) return null;
          const startTimeStr = `${String(sStart.hour).padStart(2, '0')}:${String(
            sStart.minute
          ).padStart(2, '0')}`;
          const isPause = mb.source_type === 'unavailability';
          const pauseLabel =
            mb.service_name && mb.service_name.toLowerCase() !== 'pause'
              ? mb.service_name
              : 'Pause';
          const mbCapacity = !isPause ? mb._capacity || 1 : 1;
          const occupied = Math.min(mb._count, mbCapacity);
          const isPartial =
            !isPause && mbCapacity > 1 && occupied < mbCapacity;
          const overlayWidth = isPartial
            ? (occupied / mbCapacity) * 100
            : 100;
          const belegtLabel =
            mbCapacity > 1
              ? `BELEGT · ${occupied}/${mbCapacity}`
              : `BELEGT${mb._count > 1 ? ` · ${mb._count}` : ''}`;

          return (
            <div
              key={`mb-${mb.id}-${trainerId}`}
              title={`Mindbody: ${
                isPause ? pauseLabel : mb.service_name || ''
              }${mb.staff_name ? ` (${mb.staff_name})` : ''} — ${startTimeStr}${
                mbCapacity > 1
                  ? ` — ${occupied}/${mbCapacity} Plätze belegt`
                  : mb._count > 1
                    ? ` — ${mb._count} Kunden parallel`
                    : ''
              }`}
              data-testid={`mindbody-slot-${mb.id}`}
              className="absolute pointer-events-none flex items-center justify-center"
              style={{
                top: `${topPosition}px`,
                left: '0%',
                width: `${overlayWidth}%`,
                height: `${height}px`,
                background: isPause
                  ? 'repeating-linear-gradient(45deg, rgba(212,212,216,0.6), rgba(212,212,216,0.6) 8px, rgba(228,228,231,0.6) 8px, rgba(228,228,231,0.6) 16px)'
                  : 'repeating-linear-gradient(45deg, rgba(75,85,99,0.55), rgba(75,85,99,0.55) 8px, rgba(107,114,128,0.55) 8px, rgba(107,114,128,0.55) 16px)',
                zIndex: 5,
                borderTop: isPause ? '1px dashed #a1a1aa' : '1px solid #4b5563',
                borderBottom: isPause
                  ? '1px dashed #a1a1aa'
                  : '1px solid #4b5563',
              }}
            >
              <span
                className={
                  isPause
                    ? 'text-[10px] font-bold text-zinc-500 uppercase tracking-wider'
                    : 'text-[10px] font-bold text-white uppercase tracking-wider drop-shadow'
                }
              >
                {isPause ? `☕ ${pauseLabel}` : belegtLabel}
              </span>
            </div>
          );
        } catch (e) {
          return null;
        }
      })}
    </>
  );
};

export default MindbodyOverlay;
